import React from "react";
import styles from "./Page01.module.scss";
import { useBlocks } from "@jelly/lesson";
import { AudioPlayerBlock } from "@src/lms/jelly/extensions/blocks/audioPlayer/AudioPlayerBlock";

type singleBlockData = {
  name: string;
  samples: Array<{ title: string; src: string }>;
};

export interface Lesson0504Page01Props {
  infoBoxText?: string;
  example1: singleBlockData;
  example2: singleBlockData;
}

export const Lesson0504Page01: React.FC<Lesson0504Page01Props> = (props) => {
  const block = useBlocks();

  function renderBlock(data: singleBlockData): React.ReactNode {
    return (
      <div className={styles.blockWrapper}>
        <div className={styles.descriptionWrapper}>
          <h2>{data.name}</h2>
        </div>
        <div className={styles.audioWrapper}>
          <AudioPlayerBlock key={data.name} samples={data.samples} reversePlayer={true} />
        </div>
      </div>
    );
  }

  return (
    <div className={styles.pageWrapper}>
      {props.infoBoxText && (
        <div className={styles.infoBoxWrapper}>
          <block.infoBox text={props.infoBoxText} icon="cil-headphones" compact={true} />
        </div>
      )}

      <div className={styles.blocksWrapper}>
        {renderBlock(props.example1)}
        <div className={styles.verticalLine}></div>
        {renderBlock(props.example2)}
      </div>
    </div>
  );
};
